import React from "react";
import "react-tabs/style/react-tabs.css";
import { Table } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import {Card} from "react-bootstrap";
import {Col} from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Create';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { MDBChip } from "mdbreact";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//import Faq from 'react-faq-component';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';
//import 'react-accessible-accordion/dist/fancy-example.css';
class DriverFaqs extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {

    }
    this.handleChange = this.handleChange.bind(this);
    //this.hndleAsset = this.handleAsset.bind(this);
   // this.submitHandler = this.submitHandler.bind(this);
  }
 

  handleChange = event => {
    this.setState({ partnerId: event.target.value });
  };

//   handleAsset = () => {
//     this.setState({ partnerType: this.state.partnerId });
//   };

  nextPath(path) {
    console.log(path);
    this.props.history.push(path);
  }

  onOpeningsChange(e) {  
    this.setState({openings:e});   
}
handleCloseHere = (param) => (e) => {
  this.setState({
    ['show' + param]: false
  })
}


  render() {
   
    return (
      <>      
        <div className="kt-wizard-v1__form">
        <Breadcrumb>
          <Breadcrumb.Item active>Faq</Breadcrumb.Item>
        </Breadcrumb>   
       <Card>
            <Card.Body>  
          
            <Accordion>
            <AccordionItem>           
                <AccordionItemHeading>
                {/* <i class="flaticon2-layers-1"></i> */}
                    <AccordionItemButton>             
                    Why should I partner with GoWatr?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>                
                    <p>
                    You will be eligible for many benefits once your tanker is affiliated to GoWatr.
                                        
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton >                   
                    What benefits will I get by attaching my tankers to GoWatr? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    The key benefits are: assured trips and increased earnings.     
                    </p>
                </AccordionItemPanel>                
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    How will I get deliveries on a daily basis? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    You will be duly notified.  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>           
    

        <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    What assurance do I get from GoWatr for my business? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Through assured trips, coupled with benefits based on the classification of your tanker.  

                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    What are the schemes available? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    The three available schemes are: Platinum, Gold and Silver.  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Will I receive priority for deliveries? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Yes, the load and delivery assignment will be based on the tanker’s classification
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    When will I receive my payments?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Your payments will be made by the first week of every month.   

                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    How do I become a GoWatr fleet operator?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Once you have signed up with us and your vehicles are 
                    affiliated to GoWatr, you will become our fleet operator. 
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Can I have multiple drivers for my tanker? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Yes, one or more drivers can be deployed to drive any tanker for the daily operations.

                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    What kind of support will I get from GoWatr to handle my daily fleet management?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Assured trips and absence of idle time for the tankers.  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    How will I get assured business throughout the year? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    It will be based on your delivery performances and through customer ratings.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Where should I collect water for my deliveries?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    You will be directed to our affiliated bore-wells.  

                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Who will pay the bore-well owners?  
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    GoWatr will pay the bore-well owners.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Will I be able to arrange and deliver water to my customers?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    No. Once you are affiliated to GoWatr, your deliveries will 
                    be limited to our customers only.  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Will GoWatr pay my drivers directly?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    No. GoWatr will not make any payments to them.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Who should I contact in case of any queries about my earnings?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    You can contact GoWatr’s Customer Relations Executive (CRE).  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    How can I view my earnings?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    It can be viewed on the dashboard.  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            {/* <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Is GoWatre App compatible for all OS versions?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Yes, OTS app is compatible with both Android and iOS.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Can I order tankers on Public holiday?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Yes, you can book tankers on public holidays as well.  
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Tankers are normally delivered late in the night, 
                    this disturb my sleeping time. How the OTS app handle this?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    You can always a point of contact to your address, (i.e., you can give the number of your watchman,
                     so that the lorry guy will call the watchman for delivery instead of calling you)
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Is the rates are fixed or variable during seasonal and non-seasonal periods? 
                    If so, what is the percentage of variables?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Yes, rates and prices will vary as per season. Almost 30-40% will the spike in prices
                     during seasonal periods when compared to non-seasonal periods.
                    </p>
                </AccordionItemPanel>
            </AccordionItem> */}

        </Accordion>
</Card.Body>     
    </Card> 
    </div>
   
      </>
    );
  }
}

export default withRouter(DriverFaqs);